import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@mui/material';
import { useStyles } from '../styles';
import { SortType, TabIndex } from '../types';

interface SortMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSortChange: (sortType: SortType) => void;
  currentSort?: SortType;
  activeTab?: number;
}

export const SortMenu: React.FC<SortMenuProps> = ({ anchorEl, onClose, onSortChange, currentSort, activeTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSortClick = (sortType: SortType) => {
    onSortChange(sortType);
    onClose();
  };

  const isRequiredTab = activeTab === TabIndex.REQUIRED;

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      className={classes.sortMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem
        className={classes.menuItem}
        data-testid="my-certifications-sort-name-asc"
        onClick={() => handleSortClick(SortType.NAME_ASC)}
        selected={currentSort === SortType.NAME_ASC}
      >
        {t('myCertifications.sort.nameAtoZ')}
      </MenuItem>
      <MenuItem
        className={classes.menuItem}
        data-testid="my-certifications-sort-name-desc"
        onClick={() => handleSortClick(SortType.NAME_DESC)}
        selected={currentSort === SortType.NAME_DESC}
      >
        {t('myCertifications.sort.nameZtoA')}
      </MenuItem>
      {!isRequiredTab && (
        <>
          <MenuItem
            className={classes.menuItem}
            data-testid="my-certifications-sort-date-asc"
            onClick={() => handleSortClick(SortType.DATE_ASC)}
            selected={currentSort === SortType.DATE_ASC}
          >
            {t('myCertifications.sort.dateOldToNew')}
          </MenuItem>
          <MenuItem
            className={classes.menuItem}
            data-testid="my-certifications-sort-date-desc"
            onClick={() => handleSortClick(SortType.DATE_DESC)}
            selected={currentSort === SortType.DATE_DESC}
          >
            {t('myCertifications.sort.dateNewToOld')}
          </MenuItem>
        </>
      )}
    </Menu>
  );
};
